<template>
    <div class="wrapper">
        <h1 class="crumb">询价单列表</h1>
        <!--<button style="width: 100px;height: 35px;font-size: 16px;border: 0;cursor: pointer; color: #ffffff;background: #f56c31;border-radius: 2px;" @click="addInquiry">添加询价单</button>-->
        <el-table
            :data="inqueryList"
            style="width: 100%;margin-top: 20px;">
            <el-table-column  label="操作" align="center" width="200">
                <template slot-scope="props">
                    <el-button type="text" size="small" @click="AddToPro(props.row.id)" style="width: 40%;margin-left: 0;" v-show="props.row.status === '0'">确认</el-button>
                    <el-button type="text" size="small" @click="returnInq(props.row.id)" style="mwidth: 40%;margin-left: 0;" v-show="props.row.status === '1'">取消确认</el-button>
                    <el-button type="text" size="small" @click="Dayin(props.row)" style="width: 40%;margin-left: 0;">打印</el-button>
                    <el-button type="text" size="small" @click="Xiazai(props.row)" style="width: 40%;margin-left: 0;">下载</el-button>
                    <!--<el-button type="text" size="small" @click="Edit(props.row)" style="margin: 0 10px">编辑</el-button><span> | </span>-->
                    <el-button type="text" size="small" @click="Delete(props.row)" style="width: 40%;margin-left: 0;" v-show="props.row.status==='0'">删除</el-button>
                </template>
            </el-table-column>
            <el-table-column prop="addtime" label="询价日期" align="center" :formatter="formatter"></el-table-column>
            <el-table-column label="型号"  align="center" width="200">
                <template slot-scope="props">
                    <div v-for="item in props.row.goods" style="font-size: 10px">{{item.goods_attr}}</div>
                </template>
            </el-table-column>
            <el-table-column label="数量" width="50" align="center">
                <template slot-scope="props">
                    <div v-for="item in props.row.goods">{{item.goods_number}}</div>
                </template>
            </el-table-column>
            <el-table-column label="单价" width="100"  align="center">
                <template slot-scope="props">
                    <div v-for="item in props.row.goods">{{+item.goods_price}}</div>
                </template>
            </el-table-column>
            <el-table-column label="成套/单品"  align="center" width="100">
                <template slot-scope="props">
                    <div v-for="item in props.row.goods" style="font-size: 10px">{{item.style}}</div>
                </template>
            </el-table-column>
            <el-table-column label="修改" width="100"  align="center">
                <template slot-scope="props">
                    <div v-for="item in props.row.goods" @click="changeGoods(item)"><a>修改商品</a></div>
                </template>
            </el-table-column>
            <el-table-column label="总额" width="100"  align="center">
                <template slot-scope="props">
                    <div>{{props.row.allPrice}}</div>
                </template>
            </el-table-column>
            <el-table-column prop="login_account" label="登录号" align="center"></el-table-column>
            <el-table-column prop="user_store" label="询价部门" align="center"></el-table-column>
            <el-table-column prop="post_name" label="询价人" align="center"></el-table-column>
            <el-table-column prop="address" label="地址" align="center"></el-table-column>
            <el-table-column prop="content" label="备注" align="center"></el-table-column>
            <el-table-column label="状态" width="100"  align="center">
                <template slot-scope="props">
                    <div :style="props.row.status==='0'?{color:'red'}:{color:'green'}">{{props.row.status==='0'?'未确认':'已确认'}}</div>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @current-change="handleCurrentChange"
            layout="total, prev, pager, next"
            :total="total">
        </el-pagination>
        <!--修改商品信息-->
        <el-dialog title="编辑商品" :visible.sync="EditShop" width="500px">
            <el-form :model="editForm">
                <!--<el-form-item label="商品名称" :label-width="formLabelWidth">-->
                    <!--<button class="edit-button">{{editForm.goods_name}}</button>-->
                <!--</el-form-item>-->
                <el-form-item label="商品价格" :label-width="formLabelWidth">
                    <el-input v-model="editForm.goods_price" style="width: 120px"> </el-input>
                </el-form-item>
                <!--<el-form-item label="商品数量" :label-width="formLabelWidth">-->
                    <!--<el-input-number v-model="editForm.goods_number" :min="1" :max="99" size="small"></el-input-number>-->
                <!--</el-form-item>-->
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="EditShop = false">取 消</el-button>
                <el-button type="primary" @click="changeShop">确 定</el-button>
            </div>
        </el-dialog>
        <!--编辑订单-->
        <el-dialog title="编辑" :visible.sync="EditMsg" width="500px">
            <el-form :model="Edits">
                <el-form-item label="登录号" :label-width="formLabelWidth">
                    <el-input v-model="Edits.login_account" style="width: 80%"> </el-input>
                </el-form-item>
                <el-form-item label="地址" :label-width="formLabelWidth">
                    <el-input type="textarea" v-model="Edits.address" style="width: 80%"> </el-input>
                </el-form-item>
                <el-form-item label="备注" :label-width="formLabelWidth">
                    <el-input v-model="Edits.content" style="width: 80%"> </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="EditMsg = false">取 消</el-button>
                <el-button type="primary" @click="qrEdit">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import {InquiryList, InquiryToPro, EditInquiry, ProjectToInq} from "../stores/api";

    export default {
        data() {
            return {
                page: 1,
                total: '',
                inqueryList: [],
                editForm: '', //商品参数列表
                Edits: {},
                EditShop: false,
                EditMsg: false,
                formLabelWidth: '120px',
            }
        },
        created () {
            this.getInqueryList()
        },
        methods: {
            formatter(row) {
                return new Date(row.addtime * 1000).toLocaleDateString().toString().replace(/\//g, '-')
            },
            getInqueryList () {
                let temp = {}
                temp.page = this.page
                InquiryList(temp).then(res => {
                    if (res.data.error === 0) {
                        this.inqueryList = res.data.list
                       res.data.list.forEach((items, i) => {
                           this.inqueryList[i].goods.forEach((item, j) => {
                               this.inqueryList[i].goods[j].pid = items.id
                               this.inqueryList[i].goods[j].address = items.address
                               this.inqueryList[i].goods[j].address_id = items.address_id
                               this.inqueryList[i].goods[j].login_account = items.login_account
                               this.inqueryList[i].allPrice = 0
                               this.inqueryList[i].goods.forEach(item => {
                                   this.inqueryList[i].allPrice += item.goods_price * item.goods_number
                               })
                               console.log(this.inqueryList[i].goods[j].allPrice)
                           })
                       })
                        this.total = res.data.count
                    }
                })
            },
            //询价单添加到项目列表
            AddToPro (id) {
                let temp = {}
                temp.id = id
                this.$confirm('确定把该询价单添加到项目列表?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'success'
                }).then(() => {
                    InquiryToPro(temp).then(res => {
                        if (res.data.error === 0) {
                            this.$message({
                                type: 'success',
                                message: res.data.msg
                            });
                            this.getInqueryList()
                        }
                    })
                })
            },
            //取消询价单
            //退回询价单
            returnInq (id) {
                let temp = {}
                temp.id = id
                this.$confirm('确定退回该询价单?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'success'
                }).then(() => {
                    //退回询价单
                    ProjectToInq(temp).then(res => {
                        if (res.data.error === 0) {
                            this.$message({
                                type: 'success',
                                message: res.data.msg
                            });
                            this.getInqueryList()
                        }
                    })
                })
            },
            Dayin(row) {
                localStorage.setItem('DayinData', JSON.stringify(row))
                let routeData = this.$router.resolve({
                    name: "Dayin",
                });
                window.open(routeData.href, '_blank');
            },
            //删除询价单
            Delete(row) {
                this.$confirm('确定删除该询价单?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'error'
                }).then(() => {
                    this.$http.post(this.$reqUrl + `user.php?act=inquiry_del&id=${row.id}`).then(res => {
                        if (res.data.error === 0) {
                            this.$message.success('删除成功')
                            this.getInqueryList()
                        }
                    })
                })
            },
            //编辑订单
            Edit(row) {
              this.EditMsg = true
              this.Edits = row
            },
            //确认修改
            qrEdit() {

            },
            //修改询价单商品
            changeGoods (row) {
                console.log(row)
                this.EditShop = true
                this.editForm = row
            },
            changeShop () {
              console.log(this.editForm)
                this.editForm.goods_price = Number(this.editForm.goods_price)
                let data = {
                    address: this.editForm.address,
                    address_id: this.editForm.address_id,
                    goods: [{ goods_attr: this.editForm.goods_attr, goods_attr_id: this.editForm.goods_attr_id, goods_name: this.editForm.goods_name, goods_number: this.editForm.goods_number, goods_price: this.editForm.goods_price, id: this.editForm.id, }],
                    id: this.editForm.pid,
                    login_account: this.editForm.login_account
                }
                EditInquiry(data).then(res => {
                    if (res.data.error === 0) {
                        this.$message.success(res.data.msg)
                        this.getInqueryList()
                        this.EditShop = false
                    }
                })
            },
            //点击换页
            handleCurrentChange (val) {
                this.page = val
                this.getInqueryList()
            },
            //跳转添加询价单界面
            addInquiry () {
              this.$router.push({path: 'InquirySheet'})
            },
        }
    }
</script>
<style lang="less" scoped>
    .wrapper{
        .edit-button{
            padding: 8px 15px;
            border: 0;
            background: white;
            color: #f56c31 ;
            border: 1px solid #f56c31;
        }
    }
</style>
<style>
    .el-table th>.cell{
        color: #f56c31;
    }
</style>



// WEBPACK FOOTER //
// src/router/InquiryList.vue